import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'etiquetado',
})
export class EtiquetadoPipe implements PipeTransform {

  transform(items: any[], filtros: { id_familia: any[], id_familia_top: any, menu: any }): any[] {

    if (items) {

      if (filtros) {

        // if (filtros.id_familia && filtros.id_familia.length > 0) {
        //   items = items.filter((item) => {
        //     if (filtros.id_familia.indexOf(item.id_familia) !== -1) {
        //       return item;
        //     }
        //   });
        // }


        if (filtros.id_familia_top) {
          items = items.filter((item) => item.id_familia == filtros.id_familia_top);
        }


        if (filtros.menu) {
          let now = new Date();
          let ahora = now.getTime();

          switch (filtros.menu) {
            case 'cad':
              items = items.filter((item) => item.fecha_caducidad && item.fecha_caducidad < ahora);
              break;

            case 'fav':
              items = items.filter((item) => item.favorito);
              break;
          }
        }

      }

      return items;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/etiquetado/etiquetado.ts